<template>
  <div class="dashboard">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-home"></use>
      </svg>
    </breadcrumbs>
    <noticeTool />
  
      <div class="content-main" ref="mainRef">
        <a-spin :spinning="spinningTop">
        <div class="total-view">
          <div class="left">
            <generalView :dataStatistics="dataStatistics" />
          </div>
          <div class="right">
            <nextSteps :nextStepsData="nextStepsData" :setOpenWelcome="setOpenWelcome" />
          </div>
        </div>
        </a-spin>
        <a-spin :spinning="spinning">
        <div class="chart-content">
          <div class="update-time">
            <div class="content-head-left">
              <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" @change="onChangeTab"/>
            <p>
              <span v-if="tagNumParams.lastUpdateAt">
                {{ $t('seller.common.lastUpdateAt') }}
                {{
                  moment(tagNumParams.lastUpdateAt).format("YYYY-MM-DD hh:mm")
                }}
              </span>
            </p>
            </div>
            <artmisads-select-button @click="onOpenReports" :showNextIcon="true">{{ $t('seller.common.seeAllReporting') }}</artmisads-select-button>
          </div>
          <div class="filter">
            <dateFilter :params="params" :getList="getChartList" :setParams="setParams" platform="seller" />
          </div>
          <div class="tags">
            <filterTag :setParams="setParams" :tagNumParams="tagNumParams" :marketplace="params.marketplace"
              :noNeedList="noNeedList" :defaultMetricName="params.metricName" :tagMomMapData="tagMomMapData" />
          </div>
          <p class="metric-name">
            {{ RESPORTS_TYPE_MAP[params.metricName].name }}
          </p>
          <div class="chart">
            <chart :dataList="chartList" :width="chartWidth" showYName="metricValue" showXName="reportDateTimestamp"
              :lineColor="chartParams.lineColor" :isPercent="params.metricName === 'acosAmount'"
              :lineBgOffsetTop="chartParams.lineBgOffsetTop" :lineBgOffsetZero="chartParams.lineBgOffsetZero"
              chartType="line" :selectDaysNum="selectDaysNum" :showCurrent="false"
              :startTimestamp="params.startReportDateTimestamp" :endTimestamp="params.endReportDateTimestamp"
              :metricName="params.metricName" />
          </div>
          <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            {{ $t('seller.common.noteAttribution') }}
          </p>
        </div>
         </a-spin>
        <div class="product-publisher">
          <div class="product" v-if="topProductList.length">
            <productTemp :topProductList="topProductList" :marketplace="params.marketplace" />
          </div>
          <div class="publisher" v-if="publisherList.length">
            <publisherTemp :publisherList="publisherList" :marketplace="params.marketplace" />
          </div>
        </div>
      </div>
   
    <a-drawer v-model:open="openWelcome" class="custom-class" root-class-name="root-class-name"
      :root-style="{ color: 'blue' }" width="690" placement="right">
      <welcome />
    </a-drawer>
    <!-- 暂时隐藏 -->
    <profile-modal :configs="modalSetting" @bind="reAuthorize" @change="setModalType" />
    <linkBonus ref="linkBonusRef"/>

    <lineChartModal v-if="showlineChartModal" :title="$t('seller.common.brandReport')" :itemInfo="itemInfo" :onCancleModal="onCancleModal"
      pageType="sellerBrand" :marketplace="params.marketplace" :noNeedList="['commissionAmount','finalCommissionAndFeeAmount',
        'finalCommissionAmount']" />
    <newUserModal v-if="showNewUserModal" :setShowNewUserModal="setShowNewUserModal" />
    <creatorConnectionsModal ref="creatorConnectionsModalRef"/>
  </div>
</template>
<script setup>
import i18n from '~/i18n'
import creatorConnectionsModal from "./creatorConnectionsModal.vue"
import { computed, onMounted, onUnmounted, ref, watch, onBeforeMount, reactive ,nextTick} from "vue"
import moment from "moment"
import { useRoute, useRouter } from "vue-router"
import { CURRENCY_MAPPER } from "~/contants/common.js"
import { adminApi, reportsApi, sellerDashboardApi } from "~/server/index"
import { RESPORTS_TYPE_MAP } from "~/contants/reports"
import breadcrumbs from "~/pages/seller/breadcrumbs.vue"
import filterTag from "~/components/reports/filterTag.vue"
import chart from "~/components/reports/chart.vue"
import productTemp from "./productTemp.vue"
import publisherTemp from "./publisherTemp.vue"
import profileModal from "./profileModal.vue"
import newUserModal from "./newUserModal"
import generalView from "./generalView.vue"
import welcome from "./welcome.vue"
import nextSteps from "./nextSteps.vue"
import dateFilter from "./dateFilter.vue"
import { useUserInfoStore } from "~/storeData/index"
import linkBonus from "./newUserModal/linkBonus.vue"
import { useSystemStore } from '@/storeData/system'
import { useI18n } from 'vue-i18n'
const creatorConnectionsModalRef = ref()
const { t, locale } = useI18n()
const systemStore = useSystemStore()
const route = useRoute()
const userInfo = useUserInfoStore().userInfo

const breadcrumbsData = computed(() => ({
  title: t('seller.menu.dashboard'),
  color: "#26AADC",
  des: t('seller.common.welcomeDashboard'),
  hasTitleIcon: true,
  links: [
    { name: t('seller.common.home'), path: "/seller/dashboard" },
    { name: t('seller.menu.dashboard'), path: "/seller/dashboard" },
  ],
}))
const noNeedList=ref(['commissionAmount', 'conversionsRate','quantity','finalCommissionAndFeeAmount',
        'finalCommissionAmount'])
const activeTab = ref('0')
const programConfig = computed(() => {
  locale.value
  const src = systemStore.programConfig
  if (!src?.length) return src
  return src.map((item, idx) => {
    if (idx === 0) return { ...item, label: i18n.global.t('seller.common.amazonAttribution') }
    if (idx === 1) return { ...item, label: i18n.global.t('seller.common.amazonAssociate') }
    return { ...item }
  })
})
const modalSetting = reactive({
  data: [],
  isFailed: false,
  isOldUser: false,
  waitingOpen: false,
})
const showNewUserModal = ref(false)
const openWelcome = ref(false)
const router = useRouter()
const store = useUserInfoStore()
const nextStepsData = ref([])
const dataStatistics = ref({
  totalActiveBrands: 0,
  totalActiveProducts: 0,
  totalBrands: 0,
  totalProducts: 0,
})
const tagMomMapData = ref({})
const topProductList = ref([])
const publisherList = ref([])
const showlineChartModal = ref(false)
const chartWidth = ref(1092)
const spinning = ref(false)
const chartList = ref([])
const params = ref({
  marketplace: "amazon.com",
  startReportDateTimestamp: moment().subtract(30, "day").valueOf(),
  endReportDateTimestamp: moment().valueOf(),
  brandId: null,
  productId: null,
  metricName: "clicks",
  asin: null,
})
const marketplace = CURRENCY_MAPPER[store.userInfo.countryCode].host
const isResetting = ref(false)
const spinningTop = ref(false)
const reserParams = async() => {
  isResetting.value = true

  nextTick(() => {
   params.value = {
  marketplace: marketplace,
  startReportDateTimestamp: moment().subtract(30, "day").valueOf(),
  endReportDateTimestamp: moment().valueOf(),
  brandId: null,
  productId: null,
  metricName: activeTab.value == '0' ? "clicks" : "quantity",
  asin: null,
    }
  })
  nextTick(() => {
      isResetting.value = false
    })
}


const itemInfo = ref()
const mainRef = ref()
const linkBonusRef = ref()
const topParams = ref({
  marketplace: '',
  page: 1,
  size: 200,
  sortDirection: "desc",
  sortField: "salesAmount",
  startReportDateTimestamp: moment().subtract(30, "day").valueOf(),
  endReportDateTimestamp: moment().valueOf(),
})

const tagNumParams = ref({
  totalClicks: null,
  totalDetailPageViews: null,
  totalAddToCart: null,
  totalConversions: null,
  totalSalesAmount: null,
  totalDiscountedSalesAmount: null,
  totalBonusAmount: null,
  totalCommissionAndFeeAmount: null,
  lastUpdateAt: null,
})

const reAuthorize = code => {
  modalSetting.isOldUser = false
  modalSetting.waitingOpen = true
  adminApi.reauthorize({
    amazonAuthorizationCode: code,
    amazonCountryCode: userInfo.countryCode
  }).then(res => {
    modalSetting.waitingOpen = false
    if (res.success) {
      if (res.data?.length) {
        modalSetting.isFailed = true
        modalSetting.data = res.data
      } else {
        message.success(i18n.global.t('seller.msg.success'), 1)
        let _user = JSON.parse(JSON.stringify(userInfo))
        _user.oldUser = 'N'
        userStore.setUserInfo(_user)
      }

    }
  })
}

onBeforeMount(() => {
  if (userInfo?.oldUser === 'Y') {//拿到旧用户的amazon用户信息
    modalSetting.isOldUser = true
  }
})

const setModalType = type => {
  if (type == 'fail') {
    modalSetting.isOldUser = true
  }
}
const setShowNewUserModal = status => {
  showNewUserModal.value = status
}

const setOpenWelcome = status => {
  openWelcome.value = status
}


const selectDaysNum = computed(() => {
  const { endReportDateTimestamp, startReportDateTimestamp } = params.value
  const intervalDays = moment(endReportDateTimestamp).diff(
    moment(startReportDateTimestamp),
    "days"
  )
  return intervalDays
})

const chartParams = computed(() => {
  let lineColor, lineBgOffsetTop, lineBgOffsetZero, chartParamsData, itemData
  itemData = RESPORTS_TYPE_MAP[params.value.metricName]
  lineColor = itemData.lineColor
  lineBgOffsetTop = itemData.lineBgOffsetTop
  lineBgOffsetZero = itemData.lineBgOffsetZero
  chartParamsData = { lineColor, lineBgOffsetTop, lineBgOffsetZero }
  return chartParamsData
})

const getChartList = async () => {
 
  const temp = { ...params.value }

  if (temp.metricName == 'acosAmount') {
    temp.metricName = 'acos'
  }
  let res
  if(activeTab.value == '0'){
    res = await reportsApi.getSellerCommissionReportsPerformanceDailyMetric(temp)
  }else{
    res = await reportsApi.getSellerCommissionReportsPerformanceDailyMetricAssociate(temp)
  }
 
  if (res.success) {
    chartList.value = temp.metricName == 'acos' ? res.data.map(item => {
      return {
        ...item,
        metricValue: (item.metricValue * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
      }
    }) : res.data
  }

}

const getChartWidth = () => {
  const $chart = document.querySelector(".chart")
  const widthNum = $chart.clientWidth - 20
  chartWidth.value = widthNum
}

const setParams = (obj) => {
  const newObj = { ...params.value, ...obj }
  params.value = newObj
}
const onChangeTab = async(key) => {
  await reserParams()
  if(key == '0'){
    noNeedList.value = ['commissionAmount', 'conversionsRate','quantity', 'finalCommissionAndFeeAmount',
        'finalCommissionAmount']
  }else{
    noNeedList.value = ['clicks', 'detailPageViews', 'addToCart', 'conversions', 'conversionsRate', 'acosAmount', 'discountedSalesAmount', 'bonusAmount', 'commissionAmount', 
        'finalCommissionAmount']
  }
  // getSellerCommissionReportsAgg()
  // getChartList()
}
watch([params, activeTab], async ([newValue, oldValue], [newactiveTab, oldactiveTab]) => {
  if (isResetting.value) {
    return
  }
  if (newValue.metricName !== oldValue.metricName && newactiveTab == oldactiveTab) {
    spinning.value = true
    await getChartList()
    spinning.value = false
  } else {
    getAllData()
  }
}, { deep: true, flush: 'post' })

const onCancleModal = () => {
  showlineChartModal.value = false
  itemInfo.value = undefined
}
const checkPopActive = () => {
  adminApi.getPopActive().then((res) => {
    const { success, data } = res
   
    if (success) {
     if(data.keys.length > 0){
      if(data.keys.includes('acc_bonus_program_released')){
        creatorConnectionsModalRef.value?.showModal()
      }
     }
    }
  })
}
const getTopData = async () => {
  spinningTop.value = true
  try {
    await Promise.all([
    sellerDashboardApi.getSellerDashboardDataStatistics().then((res) => {
    const { success, data } = res
    if (success) {
      dataStatistics.value = data
    }
  }),
  sellerDashboardApi.getSellerDashboardNextSteps().then((res) => {
    const { success, data } = res
    if (success) {
      nextStepsData.value = data
    }
  }),
  checkPopActive()
  ])
  } catch (error) {
    console.error('请求执行失败:', error);
  } finally {
    spinningTop.value = false
  }

}
const getData = async () => {
try { 
  await Promise.all([
  reportsApi
    .getSellerCommissionReportsProduct(topParams.value)
    .then((res) => {
      const { success, data } = res
      if (success && data.data.length) {
        topProductList.value = data.data.splice(0, 6)
      }
    }),
  reportsApi
    .getSellerCommissionReportsPublisher(topParams.value)
    .then((res) => {
      const { success, data } = res
      if (success && data.data.length) {
        publisherList.value = data.data.splice(0, 6)
      }
    })
  ])  
} catch (error) {
  
}
  
 
}

const getSellerCommissionReportsAgg = async () => {
 
  let newParams = { ...params.value },
    startDate,
    endDate,
    intervalTime,
    vsValue = []
  intervalTime =
    newParams.endReportDateTimestamp - newParams.startReportDateTimestamp
  newParams.startReportDateTimestamp =
    newParams.startReportDateTimestamp - intervalTime
  newParams.endReportDateTimestamp =
    newParams.endReportDateTimestamp - intervalTime
  let resNew, resOld
  if(activeTab.value == '0'){
    resNew = await reportsApi.getSellerCommissionReportsAgg(params.value)
    resOld = await reportsApi.getSellerCommissionReportsAgg(newParams)
  }else{
    resNew = await reportsApi.getSellerCommissionReportsAggAssociate(params.value)
    resOld = await reportsApi.getSellerCommissionReportsAggAssociate(newParams)
  }
 
  if (resNew.success) {
    const newData = resNew.data
    tagNumParams.value = newData
    if (resOld.success) {
      const oldData = resOld.data
      let momMap = {}
      for (let key in resNew.data) {
        let itemData = {}
        let oldValue = oldData[key], newValue = newData[key]
        if (newValue === 0 && oldValue === 0) {
          if (oldValue === 0) {
            itemData.type = "zero"
            itemData.value = `MoM 0.00%`
          }
        } else if (newValue === 0 && oldValue !== 0) {
          itemData.type = "down"
          itemData.value = `MoM -100.00%`
        } else if (newValue !== 0 && oldValue === 0) {
          itemData.type = "up"
          itemData.value = `MoM +100.00%`
        } else {
          let percent = ((newValue - oldValue) / oldValue) * 100
          if (percent === 0) {
            itemData.type = "zero"
            itemData.value = `MoM 0.00%`
          } else {
            percent = percent.toFixed(2)
            if (percent > 0) {
              itemData.type = "up"
              itemData.value = `MoM +${percent}%`
            } else {
              itemData.type = "down"
              itemData.value = `MoM ${percent}%`
            }
          }
        }
        momMap[key] = itemData
      }
      tagMomMapData.value = momMap
    }
  }

}

const checkNewUser = () => {
  // showNewUserModal.value = store.userInfo.onboardingCompleted !== 'N';
  showNewUserModal.value = store.userInfo.onboardingCompleted === 'N'
}

const onOpenReports = () => {
  const { href } = router.resolve({ path: '/seller/reports/performance' })
  window.open(href, '_self')
}

// const closeLinkBonus = () => {
//   if (route.query.t) {
//     modalSetting.waitingOpen = true
//   }
// }
const getAllData = async () => {
  spinning.value = true
  try {
  await Promise.all([
    getSellerCommissionReportsAgg(),
    getChartList()
  ])
  } catch (error) {
    console.error('请求执行失败:', error);
  } finally {
    spinning.value = false
  }

}
onMounted(async() => {

  document.querySelector('.dashboard').scrollIntoView()
  
  if (route.query.t) {
    modalSetting.waitingOpen = true
  }
  if(route.query.isLogin){
  if (store.userInfo.associateCompleted === 'N') {
    linkBonusRef.value.showModal()
  }
  }
  params.value.marketplace = marketplace
  topParams.value.marketplace = marketplace
  getChartWidth()
  getAllData()
  document.querySelector('.dashboard') && window.addEventListener("resize", function () {
    getChartWidth()
  })
  getData()
  getTopData()
  checkNewUser()
})

</script>
<style lang="less" scoped>
.dashboard {
  padding: 0 16px;

  .content-main {
    border-radius: 12px;
    overflow: hidden;
    border-radius: 12px;

    .update-time {
      display: flex;
      justify-content: space-between;
      padding: 4px 4px 16px 4px;
       .content-head-left {
        display: flex;
        align-items: center;
        gap: 14px;
      }
      >p {
        font-size: 14px;
        color: var(--dark-2);
        line-height: 19px;
        align-self: center;
      }

      button {
        align-self: center;
      }
    }

    .total-view {
      width: 100%;
      display: flex;

      .left {
        width: 63%;
      }

      .right {
        width: 37%;
        margin-left: 16px;
      }
    }
  }

  .chart-content {
    padding: 12px;
    box-shadow: var(--section-box-shadow-5);
    background-color: var(--color-white);
    border-radius: 8px;
    margin-top: 16px;

    .note {
      display: flex;
      height: 32px;
      line-height: 32px;
      background-color: var(--bg-gray-6);
      border: 1px solid var(--border-4);
      color: var(--dark-3);
      font-weight: 400;
      font-size: 12px;
      letter-spacing: 0.3px;
      border-radius: 8px;
      padding: 0 8px;
      margin: 16px 4px 4px 4px;

      svg {
        width: 16px;
        height: 16px;
        fill: var(--dark-3);
        margin-right: 8px;
        align-self: center;
      }
    }

    .metric-name {
      display: flex;
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin: 40px 0 30px 4px;
    }

    .tags {}

    .chart {
      padding: 0 10px;
    }
  }

  .product-publisher {
    margin-top: 16px;
    display: flex;

    .product {
      width: 50%;
    }

    .publisher {
      width: 50%;
      margin-left: 16px;
    }
  }
}
</style>
